import { render, staticRenderFns } from "./B2cImessageList.vue?vue&type=template&id=426ed1a4&scoped=true&"
import script from "./B2cImessageList.vue?vue&type=script&lang=js&"
export * from "./B2cImessageList.vue?vue&type=script&lang=js&"
import style0 from "./B2cImessageList.vue?vue&type=style&index=0&id=426ed1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426ed1a4",
  null
  
)

export default component.exports